module.exports = __webpack_public_path__ + "static/media/two credit card.f73579df.png";